import React from 'react';
import RulesHeader from 'Components/RulesHeader';
import { useTranslation } from 'react-i18next';
import DeployedInfoText from 'Components/DeployedInfoText';
import { Button } from '@brighterion/br-ui';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { useHistory } from 'react-router-dom';

interface HeaderProps {
    isLandlordDeployment: boolean;
    allowOverride?: boolean;
}

const Header = ({ isLandlordDeployment, allowOverride }: HeaderProps) => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <RulesHeader>
            <RulesHeader.Left
                isSandbox={false}
                title={isLandlordDeployment ? t('Network Rules') : t('Global Rules')}
                useAlternateText={allowOverride}
                alternateText={t('Select Rule to Add Override')}
            />
            <RulesHeader.Right>
                {allowOverride ? (
                    <Button
                        dataTestId='addForm-cancel-btn'
                        variant='secondary'
                        size='small'
                        onClick={handleOnClickEvent(() => history.push('/global-rules'))}
                        onKeyDown={handleKeyEvent(() => history.push('/global-rules'))}
                    >
                        {t('Cancel')}
                    </Button>
                ) : (
                    <DeployedInfoText isLandlordDeployment={isLandlordDeployment} />
                )}
            </RulesHeader.Right>
        </RulesHeader>
    );
};

export default Header;
